/* @flow */

import { WEBSHOP_DESIGN_PAGE_MODULE_SPLASH } from '../../../shared'

import WebshopProductCarouselSettings from './WebshopProductCarouselSettings'
import WebshopProductCarousel from './WebshopProductCarousel'

const widget = {
  component: WebshopProductCarousel,
  settings: WebshopProductCarouselSettings,

  available_children: [],
  unavailable_in_modules: [WEBSHOP_DESIGN_PAGE_MODULE_SPLASH],
  label: 'Product carousel',

  default_settings: {
    headline: '',
    headline_font: null,
    headline_position: 'left',
    product_width: '200px',
    products: [],
    space_between_each_product: '',
  },
  default_style: {},
}

export default widget
